exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-label-bold label.v-label.v-label--active.theme--light{color:#000;font-size:22px;font-weight:bold}", ""]);

